// Анимации по классам в порядке ngAnimate 1.2.29.
// Класс (ng-hide): сразу класс подготовки ng-hide-add, длительность считается с итоговым набором
// классов; на следующем кадре меняется сам класс и добавляется ng-hide-add-active; по окончании
// классы подготовки снимаются. Вставка (ng-enter) идёт до анимации, удаление (ng-leave) — после.
// Без CSS-анимации изменение делается сразу. До окончания запуска страницы анимации выключены.

function parseSeconds(value) {
    return String(value || '0s').split(',').reduce((max, part) => {
        const text = part.trim();
        const seconds = parseFloat(text) * (text.endsWith('ms') ? 0.001 : 1);
        return Math.max(max, isNaN(seconds) ? 0 : seconds);
    }, 0);
}

function timings(element) {
    const style = window.getComputedStyle(element);
    const transition = parseSeconds(style.transitionDuration) + parseSeconds(style.transitionDelay);
    const hasAnimation = style.animationName && style.animationName !== 'none';
    const iterations = parseFloat(style.animationIterationCount) || 1;
    const animation = hasAnimation
        ? parseSeconds(style.animationDuration) * iterations + parseSeconds(style.animationDelay)
        : 0;
    return Math.max(transition, animation);
}

function nextFrame(fn) {
    if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => fn());
    } else {
        setTimeout(fn, 16);
    }
}

export function createAnimate() {
    let enabled = false;
    const running = new WeakMap();

    // classBased: изменение DOM делается вместе с классом -active, иначе — в конце (удаление).
    function run(element, setup, measure, domOp, classBased) {
        const previous = running.get(element);
        if (previous) {
            previous.cleanup();
        }
        if (!enabled || element.nodeType !== 1 || !element.isConnected) {
            if (domOp) {
                domOp();
            }
            return;
        }
        element.classList.add(setup);
        const duration = measure();
        if (!duration) {
            element.classList.remove(setup);
            if (domOp) {
                domOp();
            }
            return;
        }
        let finished = false;
        let domDone = false;
        let timer = null;
        const applyDom = () => {
            if (!domDone) {
                domDone = true;
                if (domOp) {
                    domOp();
                }
            }
        };
        const onEnd = event => {
            if (event.target === element) {
                state.cleanup();
            }
        };
        const state = {
            cleanup() {
                if (finished) {
                    return;
                }
                finished = true;
                running.delete(element);
                clearTimeout(timer);
                element.removeEventListener('animationend', onEnd);
                element.removeEventListener('transitionend', onEnd);
                element.classList.remove(setup, setup + '-active');
                applyDom();
            },
        };
        state.setup = setup;
        running.set(element, state);
        nextFrame(() => {
            if (finished) {
                return;
            }
            if (classBased) {
                applyDom();
            }
            element.classList.add(setup + '-active');
            element.addEventListener('animationend', onEnd);
            element.addEventListener('transitionend', onEnd);
            timer = setTimeout(() => state.cleanup(), duration * 1500 + 50);
        });
    }

    function insert(element, parent, after) {
        const container = after ? after.parentNode : parent;
        const next = after ? after.nextSibling : container.firstChild;
        // ng-if/ng-repeat вставляют блок до связывания. Повторная вставка здесь
        // создаёт лишние записи MutationObserver и повторную обработку блока.
        if (next !== element) {
            container.insertBefore(element, next);
        }
    }

    return {
        enable() {
            enabled = true;
        },
        addClass(element, className) {
            const current = running.get(element);
            // Как в ngAnimate 1.2: повтор идущей анимации не перезапускает её, класс ставится сразу.
            if (current && current.setup === className + '-add') {
                element.classList.add(className);
                return;
            }
            if (element.classList.contains(className) && !current) {
                return;
            }
            run(element, className + '-add', () => {
                element.classList.add(className);
                const duration = timings(element);
                element.classList.remove(className);
                return duration;
            }, () => element.classList.add(className), true);
        },
        removeClass(element, className) {
            const current = running.get(element);
            if (current && current.setup === className + '-remove') {
                element.classList.remove(className);
                return;
            }
            if (!element.classList.contains(className) && !current) {
                return;
            }
            run(element, className + '-remove', () => {
                element.classList.remove(className);
                const duration = timings(element);
                element.classList.add(className);
                return duration;
            }, () => element.classList.remove(className), true);
        },
        enter(element, parent, after) {
            insert(element, parent, after);
            run(element, 'ng-enter', () => timings(element), null, false);
        },
        move(element, parent, after) {
            insert(element, parent, after);
            run(element, 'ng-move', () => timings(element), null, false);
        },
        leave(element) {
            run(element, 'ng-leave', () => timings(element), () => {
                if (element.parentNode) {
                    element.parentNode.removeChild(element);
                }
            }, false);
        },
    };
}

// Правила AngularJS 1.2.29 для скрытых блоков и для анимации ng-hide.
export const ANGULAR_CSS = '[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide{display:none !important;}'
    + '.ng-hide-add-active,.ng-hide-remove{display:block!important;}';
